import {customElement} from "lit/decorators.js";
import {Resolution} from "../../../common/resolution";
import {resolve} from "../../../container";
import {ScrollService} from "../../../common/scroll";
import {EopExecutiveBoardGallery, executiveBoardGalleryConfig} from "./executiveBoardGallery";

@customElement("eop-executive-board-gallery-4-no-intro-image")
export class EopExecutiveBoardGalleryFourWithoutGroupShot extends EopExecutiveBoardGallery {

    public constructor(resolution: Resolution = resolve(Resolution), scrollService: ScrollService = resolve(ScrollService)) {
        // has duplicate in scss
        const portraitOnStageTimeline = [0, 0.32, 0.63, 0.95];
        const config = executiveBoardGalleryConfig(portraitOnStageTimeline, {portraitCount: 4, hasGroupShot: false});
        super(config, resolution, scrollService);
    }
}
